import * as React from "react";
import { memo } from "react";

import { Separator } from "@/components/ui/separator";
import { SidebarProvider, SidebarTrigger, SidebarInset } from "@/components/ui/sidebar";
import { WebshopSelector } from "@/components/WebshopSelector";
import { ModeToggle } from "@/components/mode-toggle";
import { useRenderPerformance } from "@/hooks/use-performance";

import { AppSidebar } from "./AppSidebar";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export const DashboardLayout = memo(function DashboardLayout({ children }: DashboardLayoutProps) {
  useRenderPerformance('DashboardLayout');
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 border-b bg-background sticky top-0 z-10" role="banner">
          <div className="flex items-center gap-2 px-4 w-full justify-between">
            <nav className="flex items-center gap-2" aria-label="Main navigation">
              <SidebarTrigger className="-ml-1" aria-label="Toggle sidebar" />
              <Separator orientation="vertical" className="mr-2 h-4" />
              <WebshopSelector />
            </nav>
            <ModeToggle />
          </div>
        </header>
        <main id="main-content" className="flex-1 p-6 bg-muted/30" role="main">
          {children}
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
});
